export default {
  SET_DEBUG_MODE (state, payload) {
    state.isDebugMode = payload
  },

  SET_DISABLED_URL (state, payload) {
    state.disabledUrl = payload
  },

  SET_FORM_DATA (state, payload) {
    const formData = state.formData

    if (payload.key === 'bank_iban' || payload.key === 'bank_bic') {
      formData[payload.key] = payload.value
        ? payload.value.toString().toUpperCase()
        : ''
    } else {
      formData[payload.key] = payload.value
    }

    state.formData = {
      ...formData
    }
  },

  SET_FINISHED (state, payload) {
    state.isFinished = payload
  },

  SET_SIGN_MODE (state, payload) {
    state.isSignMode = payload
  },

  SET_SIGNED (state, payload) {
    state.isSigned = payload
  },

  SET_FILE_ERROR (state, payload) {
    state.fileError = payload
  },

  SET_TOKEN (state, payload) {
    state.token = payload
  }
}
